import { itemDescription } from "../components/UpdateModal/type";

export function removeMask(value: string): string {
  return value.replace(/[-./]/gi, "");
}

export const regexPhoneFormatter = (phone: string) => {
  return phone
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(\d{4})-(\d)(\d{4})/, "$1$2-$3")
    .replace(/(-\d{4})\d+?$/, "$1");
};

export const formatCpfOnString = (cpf: string) => {
  return cpf
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const sortItems = (arr: itemDescription[]) =>
  [...arr].sort((a: itemDescription, b: itemDescription) => {
    if (a.id.indexOf("Até") > -1) {
      return -1;
    }
    const regex = /([0-9]{1,3}){1}/gm;
    const resultA = a.id.match(regex);
    const resultB = b.id.match(regex);
    if (resultA && resultB) {
      return parseInt(resultA[0], 10) - parseInt(resultB[0], 10);
    }
    return 0;
  });

export const formatCEP = (cep: string) => {
  return cep
    ? cep
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,3})$/, "$1-$2")
    : "";
};

export const formatCNPJ = (cnpj: string) => {   
  return cnpj    
    .toUpperCase()     
    .replace(/[^A-Z0-9]/g, "")     
    .replace(/([A-Z0-9]{2})([A-Z0-9])/, "$1.$2")     
    .replace(/([A-Z0-9]{3})([A-Z0-9])/, "$1.$2")     
    .replace(/([A-Z0-9]{3})([A-Z0-9])/, "$1/$2")     
    .replace(/([A-Z0-9]{4})(\d)/, "$1-$2")     
    .replace(/(-\d{2})\d+?$/, "$1"); 
};

export const handleKeyPressNumber = (e: React.KeyboardEvent) => {
  const noSpecialChars = /`|~|!|@|#|\$|%|\^|&|\*|\(|\)|\+|=|\[|\{|\]|\}|\||\\|'|<|,|\.|>|\?|\/|""|;|_|:|\D/g;
  if (
    noSpecialChars.test(e.key) &&
    e.key !== "Backspace" &&
    e.key !== "Delete" &&
    e.key !== "ArrowLeft" &&
    e.key !== "ArrowRight"
  ) {
    e.preventDefault();
  }
};
export const handleKeyPressLetters = (e: React.KeyboardEvent) => {
  if (!e.key.match(/[a-z\s]/i) && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
    e.preventDefault();
  }
};

export const flitteredDropdowns = (result: {
  data: [{ lovType: string; dadosEmpresa: [{ id: string; description: string }] }];
}) => {
  const findElement = (el: string) =>
    result.data.find(({ lovType }: { lovType: string }) => lovType === el) || { lovType: "", dadosEmpresa: [] };
  const { dadosEmpresa: golOccupation } = findElement("FINS_DRVOCC_DWLOCC_MLOV");
  const { dadosEmpresa: employees } = findElement("GOL_VB_NUM_EMPLOYEES");
  const { dadosEmpresa: golMainActivity } = findElement("GOL_VB_MAIN_ACTIVITY");
  const { dadosEmpresa: golBusinessBudget } = findElement("GOL_VB_ANNUAL_TRV_BUDGET");
  const sortedEmployees = sortItems(employees);
  const sortedBusinessBudget = sortItems(golBusinessBudget);
  return { sortedEmployees, golOccupation, golMainActivity, sortedBusinessBudget };
};

export const phoneValidation = (DDDNumber: string, PhoneNumber: string) => {
  if (DDDNumber !== "0" && PhoneNumber !== "0") {
    return `${regexPhoneFormatter(DDDNumber + PhoneNumber)}`;
  }
  return "";
};

export const formatName = (adminName: string, chooseName: string) => {
  const cleanAdminName = adminName.trimEnd();
  const firstName = cleanAdminName.split(" ").slice(0, -1).join(" ");
  const lastName = cleanAdminName.split(" ").slice(-1).join(" ");
  if (chooseName === "first") {
    return firstName;
  }
  return lastName;
};
